'use client';

import { JSX, PropsWithChildren, createContext, useContext, useState } from 'react';

export type BillingInfoContext = {
    error?: string | undefined;
    setError: (error: string | undefined) => void;
    submitText: string;
    setSubmitText: (text: string) => void;
    isEditable: boolean;
    setIsEditable: (value: boolean) => void;
};

const context = createContext<BillingInfoContext>({
    setError: () => {},
    setSubmitText: () => {},
    submitText: 'Save Changes',
    isEditable: false,
    setIsEditable: () => {},
});

export function BillingInfoContextProvider({ children }: PropsWithChildren): JSX.Element {
    const [error, setError] = useState<string | undefined>(undefined);
    const [submitText, setSubmitText] = useState<string>('Save Changes');
    const [isEditable, setIsEditable] = useState(false);

    return (
        <context.Provider
            value={{
                error,
                setError,
                submitText,
                setSubmitText,
                isEditable,
                setIsEditable,
            }}
        >
            {children}
        </context.Provider>
    );
}

export const useBillingInfoContext = (): BillingInfoContext => useContext(context);
